import { render } from "./Infos.vue?vue&type=template&id=25d177f9&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"

import "./Infos.vue?vue&type=style&index=0&id=25d177f9&lang=scss&scoped=true"
import "./Infos.vue?vue&type=style&index=1&id=25d177f9&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d177f9"]])

export default __exports__